import React, { useContext, useEffect } from 'react';
import {ProgressiveImage, computeResize} from './ProgressiveImage';
import {DatasContext} from '../datas/DatasContext';
import {DraggableDialog} from './DraggableDialog';
import Intro from './Intro';
import Outro from './Outro';

function ScrollableContent({setScrollContainerWidth}) {
    
    const {content} = useContext(DatasContext);
    const findScrollable = content.scrollables.filter(scrollable => scrollable.id === 'home');
    let scrollable = null;
    if(findScrollable) {
        scrollable = findScrollable[0];
    }

    useEffect(() => {

        const backgroundRawWidth = () => {
            let width = 0;
            if(content && content.backgrounds) {
                content.backgrounds.forEach(background => {
                    width += background.width;
                })
            }
            return width;
        }
  
        const handleResize = () => {
            const svh =  window.innerHeight;
            const [width] = computeResize(backgroundRawWidth(), content.backgrounds[0].height, svh);
            setScrollContainerWidth(width + 640);
        }
        handleResize();
        window.addEventListener('resize', handleResize());

        return () => {
            window.removeEventListener('resize', handleResize);
        }

    },[setScrollContainerWidth, content]);


    return (
        <div id="content" className='h-svh max-h-svh flex'>
            <Intro/>
            <figure id={scrollable.id} className="flex h-svh relative">
                {(content && content.backgrounds) && content.backgrounds.map(background => {
                    return (<ProgressiveImage 
                    key={background.src}
                    datas={background} 
                    className="h-svh"
                    progressSx={{width:"calc(100% - 320px)", zIndex:0, position:"absolute", left:"320px", top:"50%", transform:"translateY(-50%)"}}
                    isResponsive={true}
                />)
                })}
                {(content && content.modals) && content.modals.map((modal, index) => {
                    return (
                    <DraggableDialog key={modal.id + index} modal={modal} />
                    )
                })}
            </figure>
            <Outro/>
        </div>
    )
}

export default ScrollableContent;